import React, { useState } from 'react';
import FacebookLogin from 'react-facebook-login';
import { useGoogleLogin } from 'react-google-login';
import { useNavigate } from 'react-router-dom';
import { refreshTokenSetup } from 'utils/refreshToken';
import bannerFood from 'assets/images/banner_food.png';
import googleImg from 'assets/images/google.svg';
import personalImg from 'assets/images/personal.svg';
import FacebookIcon from '@mui/icons-material/Facebook';
import './styles.scss';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import InputField from 'components/FormField/InputField';
import { Button } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { toast } from 'react-toastify';
import ToastBody from 'components/CustomToast/ToastBody';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import logo from 'assets/images/logo.png';

const clientId = '113208815372-2sqg2cl1d9fvi8mh9ivbnl532mosff1q.apps.googleusercontent.com';

interface IFormInputs {
	email: string;
	password: string;
}

//validate with yup
const schema = yup.object({
	email: yup
		.string()
		.required('This field is required')
		//eslint-disable-next-line
		.matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, 'This is not valid email format'),
	password: yup
		.string()
		.required('This field is required')
		//eslint-disable-next-line
		.matches(
			/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/,
			'Password should containing at 8 characters, 1 number, 1 upper and 1 lowercase'
		),
});

export default function LoginPage() {
	const [toggleFormLogin, setToggleFormLogin] = useState(false);

	//Toggle Login with Email or Phone number
	const handleShowLoginEmailPhoneNumber = () => {
		setToggleFormLogin(true);
	};

	const handleHideLoginEmailPhoneNumber = () => {
		!toggleFormLogin ? navigate('/') : setToggleFormLogin(false);
	};

	//form
	const { control, handleSubmit } = useForm<IFormInputs>({
		resolver: yupResolver(schema),
	});

	//login with google
	const navigate = useNavigate();
	const onSuccess = (res: any) => {
		refreshTokenSetup(res);

		const user = res.profileObj;
		const { name, imageUrl } = user;

		localStorage.setItem('userName', name);
		localStorage.setItem('userImg', imageUrl);
		navigate('/');
	};

	const onFailure = (res: any) => {
		console.log('Login failed', res);
	};

	const { signIn } = useGoogleLogin({
		onSuccess,
		onFailure,
		clientId,
		isSignedIn: true,
		accessType: 'offline',
	});

	//login with facebook
	const [login, setLogin] = useState(false);

	//callback get data from facebook
	const responseFacebook = (response: any) => {
		localStorage.setItem('nameFb', response.name);
		localStorage.setItem('imgFb', response.picture.data.url);
		navigate('/');

		// Login failed
		if (response.status === 'unknown') {
			alert('Login failed!');
			setLogin(false);
			return false;
		}
		if (response.accessToken) {
			setLogin(true);
		} else {
			setLogin(false);
		}
	};

	//React toastify
	const showToast = () => {
		return toast(
			<ToastBody
				title="Closed !"
				desc="This feature is currently closed.Try login with Google or Facebook"
				icon={false}
			/>,
			{
				position: 'top-right',
				className: 'background__toast-setting',
				closeButton: (
					<div
						style={{
							position: 'absolute',
							top: 8,
							right: 8,
							color: '#fff',
						}}
					>
						<ExitToAppIcon sx={{ width: '2rem !important', height: '2rem !important' }} />
					</div>
				),
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			}
		);
	};

	const handleCreateAccount = () => {
		showToast();
	};

	const onSubmit = () => {
		showToast();
	};

	const handleRedirectToHome = () => {
		navigate('/');
	};

	return (
		<div className="form__login" style={{ backgroundImage: `url('${bannerFood}')` }}>
			<div className="form__login-box">
				<KeyboardBackspaceIcon
					onClick={handleHideLoginEmailPhoneNumber}
					sx={{
						position: 'absolute',
						top: '50px !important',
						left: '20px !important',
						color: '#1976d2 !important',
						fontSize: '2.6rem',
					}}
				/>
				<div className="form__login-box-main">
					<div className="form__login-box-img" onClick={handleRedirectToHome}>
						<img src={logo} alt="logo food" />
					</div>
					<div className="form__login-box-heading">
						<h3>Welcome to our restaurant</h3>
					</div>

					<div className="form__login-box-help">
						<p>
							Don't have an account? <span onClick={handleCreateAccount}>Create an account</span>
						</p>
					</div>
				</div>
				{toggleFormLogin && (
					<form className="form__login-box__main" onSubmit={handleSubmit(onSubmit)}>
						<InputField
							className="form__login-box__main-input"
							name="email"
							label="Email address"
							control={control}
							placeholder="Email/Phone Number"
						/>
						<InputField
							className="form__login-box__main-input"
							name="password"
							label="Password"
							control={control}
							placeholder="Enter your password"
						/>
						<Button className="form__login-box__main-button" type="submit" variant="contained">
							Login
						</Button>
					</form>
				)}

				{!toggleFormLogin && (
					<div className="form__login-box-content">
						<div className="form__login-box-content-p" onClick={handleShowLoginEmailPhoneNumber}>
							<img src={personalImg} alt="logo-personal" />
							<span>Email Or Phone Number</span>
						</div>

						<div className="form__login-box-content-g" onClick={signIn}>
							<img src={googleImg} alt="logo-google" />
							<span>Login With Google</span>
						</div>
						{!login && (
							<FacebookLogin
								appId="1186369935222865"
								autoLoad={false}
								fields="name,email,picture"
								scope="public_profile,email,user_friends"
								callback={responseFacebook}
								icon={
									<FacebookIcon
										sx={{
											position: 'absolute',
											top: '50%',
											transform: 'translateY(-50%)',
											left: '2rem',
											fontSize: '2.4rem !important',
											color: '#4c69ba !important',
											paddingRight: '2rem',
										}}
									/>
								}
							/>
						)}
					</div>
				)}
			</div>
		</div>
	);
}
